import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import { connect } from "react-redux";
import { homeSelector } from "redux/selectors/homeSelector";
import { getUser } from "redux/actions/home-actions";
import { isEqual } from "lodash";
import { actions as courseActions } from "redux/actions/course-actions";
import { actions as crashCourseActions } from "redux/actions/crash-course-actions";
import { actions as crashCourseProgressActions } from "redux/actions/crash-course-user-progress-actions";
import IconLogo from "images/logo-sidebar.svg";

import { courseSelector } from "redux/selectors/courseSelector";
import CertificateCrashCourse from "pages/VerifyCertificate/CertificateCrashCourse";
import { 
  notification, Modal, 
  Radio, Collapse, Space } from "antd";
import { ModalCompleteYourProfile } from "components";
import { CustomButton, CustomInput, ScaleText
} from "components";
import {CRASH_COURSE_FINAL_REVIUW} from "enum"

import CollapseDescription from "./CollapseDescription";
import HeaderCollapseMap from "./HeaderCollapseMap";
import { useHistory } from 'react-router-dom';

import {
  StepBackwardOutlined,
  StepForwardOutlined,
  CheckOutlined,
  CloseOutlined,
  CloudUploadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { crashCourseSelector } from "redux/selectors/crashCourseSelector";

const { Panel } = Collapse;

const assessmentReviuw = CRASH_COURSE_FINAL_REVIUW;

const escapeDoubleQuotesWithinString = (cadena, defaultt) => {
  try{
    let startString= '":"'; 
    let endString='","';
    let endStringTwo='"},"';
    let startObject='":["';
    let endObject='"]';
    let dentroDelRango = false;
    let dentroDelObjeto = false;
    let cadenaEscapada = '';

    for (let i = 0; i < (cadena || '').length; i++) {
      // Comprobamos si estamos dentro del rango startString y endString

      if (cadena.substring(i, i + startString.length) === startString) {
        dentroDelRango = true;
        cadenaEscapada += startString;
        i += startString.length - 1; // Saltamos al final del startString
        continue;
      } else if (cadena.substring(i, i + endString.length) === endString) {
        dentroDelRango = false;
        cadenaEscapada += endString;
        i += endString.length - 1; // Saltamos al final del endString
        continue;
      } else if(cadena.substring(i, i + endStringTwo.length) === endStringTwo){
        dentroDelRango = false;
        cadenaEscapada += endStringTwo;
        i += endStringTwo.length - 1; // Saltamos al final del endStringTwo
        continue;
      }

      if(cadena.substring(i, i + startObject.length) === startObject){
        dentroDelObjeto = true;
        cadenaEscapada += startObject;
        i += startObject.length - 1; // Saltamos al final del startObject
        continue;
      }else if(cadena.substring(i, i + endObject.length) === endObject){
        dentroDelObjeto = false;
        cadenaEscapada += endObject;
        i += endObject.length - 1; // Saltamos al final del endObject
        continue;
      }

      // Escapamos las comillas si estamos dentro del rango y no son parte de `{"` o `"}` 
      if ((dentroDelRango || dentroDelObjeto) && cadena[i] === '"' 
        && !(cadena[i - 1] === "{" && cadena[i] === '"') 
        && !(cadena[i] === '"' && cadena[i + 1] === "}")
        
      ) {
        cadenaEscapada += '\\"';
      } else {
        cadenaEscapada += cadena[i];
      }
    }

    return cadenaEscapada || defaultt;
  }catch(er){
    console.log(er)
    return defaultt
  }
}

const LeadershipProgramPage = ({
  userProfile,
  match,
  updateCrashCourseUserProgress,
  // crashCourseD,
  getCrashCourseBySlug,
  createCrashCourseUserProgress,
  getCrashCourseUserProgress,
  // crashCourseProgressD
}) => {
  const [crashCourse, setCrashCourse] = useState({})
  const [crashCourseProgress, setCrashCourseProgress] = useState({})
  const [bulCompleteProfile, setBulCompleteProfile] = useState(false);
  const [countSlides, setCountSlides] = useState(0);
  // const [countSlidesTest, setCountSlidesTest] = useState(0);
  const [relationSideIndex, setRelationSideIndex] = useState({})
  const [relationSideIndex2, setRelationSideIndex2] = useState({})
  const [conjuntSelected, setConjuntSelected] = useState([])
  const [relationSlides, setRelationSlides] = useState({})
  const [relationCorrectResponses, setRelationCorrectResponses] = useState({})
  const [responseTests, setResponsesTests] = useState({})
  const [slideSelect, setSlideSelect] = useState({})
  const [memorySlideChange, setMemorySlideChange] = useState('')
  const [pageNumber, setPageNumber] = useState(null);
  const [pageNumber2, setPageNumber2] = useState(null);
  const [modal, setModal] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [sectionActive, seSectionActive] = useState([])
  const pagesSavedControl = useRef([]);
  const pagesMantain = useRef([]);
  const clockNextSaveState = useRef(null);
  const clockNextSaveState2 = useRef(null);
  const clockNextSaveState3 = useRef(null);
  const [bulWaitDuplicate, setBulWaitDuplicate] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [uploading2, setUploading2] = useState(false)
  const [uploading3, setUploading3] = useState(false)
  const history = useHistory();
  let timeToLoad = 6000;

  useEffect(() => {
    setMemorySlideChange(match.params.id)
    return  () => {
      setMemorySlideChange('')
      if(clockNextSaveState.current){clearTimeout(clockNextSaveState.current)};
      if(clockNextSaveState2.current){clearTimeout(clockNextSaveState2.current)};
      if(clockNextSaveState3.current){clearTimeout(clockNextSaveState3.current)};
      setUploading(false)
      setUploading2(false)
      setUploading3(false)
    };
  },[])

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (uploading || uploading2 || uploading3) {
        const confirmationMessage = 'Uploading. Please wait';
        event.preventDefault();
        event.returnValue = confirmationMessage;
        return confirmationMessage; 
      }
    };

    const unblock = history.block((location, _) => {
      if (uploading || uploading2 || uploading3) {
        const confirmationMessage = 'Uploading. Please wait';
        if (window.confirm(confirmationMessage)) {
          unblock(); 
          history.push(location.pathname);
        }
        return false;
      }
    });

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      unblock();
    };
  }, [uploading, uploading2, uploading3]);

  useEffect(() => {
    if ((!(crashCourse || {}).id || (crashCourse || {}).slug !== match.params.id) && match.params.id) {
      getCrashCourseBySlug(match.params.id, (data) => {
        setCrashCourse(data || {})
      });
    }
  }, [match.params, crashCourse]);

  useEffect(() => {
    if (
      ((crashCourse || {}).CrashCourseSlides || {}) &&
      ((crashCourse || {}).CrashCourseSlides || {}).length > 0
    ) {
      setCountSlides(((crashCourse || {}).CrashCourseSlides || {}).length);
    }
  }, [crashCourse]);

  useEffect(() => {
    if (crashCourse.id) {
      getCrashCourseUserProgress(crashCourse.id,(data) => {
        try{
          let testsAnswers = JSON.parse(escapeDoubleQuotesWithinString(localStorage.getItem(`testsAnswers${crashCourse.id}`), "{}"));
          let pagesVisited = JSON.parse(escapeDoubleQuotesWithinString(localStorage.getItem(`pagesVisited${crashCourse.id}`), "[]"));
          if(((data || {}).pagesVisited || []).length > 1){
            setPageNumber(String(Math.max(...[...new Set([...((data || {}).pagesVisited || []), ...pagesVisited])].map(Number))));
          }
          setCrashCourseProgress(data || {})
          setResponsesTests({...(((data || {}).testsAnswers) || {}), ...testsAnswers});
          pagesSavedControl.current = [...new Set([...((data || {}).pagesVisited || []), ...pagesVisited])].map(String);
          pagesMantain.current = [...new Set([...((data || {}).pagesVisited || []), ...pagesVisited])].map(String);

          let dataToUpdate = {}
          if(!isEqual({...(((data || {}).testsAnswers) || {}), ...testsAnswers}, (((data || {}).testsAnswers) || {}))){
            dataToUpdate = {
              ...dataToUpdate,
              testsAnswers: {...(((data || {}).testsAnswers) || {}), ...testsAnswers},
            }
          }
          if(!isEqual([...new Set([...((data || {}).pagesVisited || []), ...pagesVisited])].map(String), (data || {}).pagesVisited || [])){
            dataToUpdate = {
              ...dataToUpdate,
              pagesVisited: [...new Set([...((data || {}).pagesVisited || []), ...pagesVisited])].map(String),
            }
          }
          if(Object.keys(dataToUpdate)?.length > 0){
            updateCrashCourseUserProgress({
              ...(dataToUpdate || {}),
              id: data?.id
            }) 
          }
        }catch(er){
          console.log(er)
        }
      });
    }
    return () => {
      setResponsesTests({});
      setPageNumber(null)
      pagesSavedControl.current = [];
      pagesMantain.current = [];
    }
  }, [crashCourse,relationSlides]);

  const startCrashCourse = () => {
    if (userProfile.memberShip !== "premium") {
      return notification.error({
        message: "You must be a premium user.",
      });
    }

    if (!userProfile?.completed || userProfile?.percentOfCompletion !== 100) {
      setBulCompleteProfile(true);
      return;
    }

    setPageNumber(1);

    setTimeout(() => {
      if (!(crashCourseProgress || {}).id && (crashCourse || {}).id) {
        createCrashCourseUserProgress({
          CrashCourseId: (crashCourse || {}).id,
          timeProgress: 0,
          testsCompleted: 0,
        },(data) => {
          if(((data || {}).pagesVisited || []).length > 1){
            setPageNumber(String(Math.max(...((data || {}).pagesVisited || []).map(Number))));
          }
          setCrashCourseProgress(data || {})
          setResponsesTests((data || {}).testsAnswers || {});
          pagesSavedControl.current = (data || {}).pagesVisited || [];
          pagesMantain.current = (data || {}).pagesVisited || [];
        })
      }
    }, 500)
  };

  useEffect(() => {
    if(crashCourse?.CrashCourseSlides && crashCourse.CrashCourseSlides.length > 0){
      let positionSlides = {};
      let positionSection = {};
      let positionSection2 = {};
      let responseD = {};
      let numSection = 0;
      let datas = (crashCourse || {}).CrashCourseSlides;

      let foxed = datas.reduce((acc, obj) => {
        acc[obj.id] = obj;
        return acc;
      }, {});
  
      let datal = (((crashCourse || {}).order || [])[0] ? (crashCourse || {}).order || [] : []).map(e => {
        return foxed[e];
      })

      for(let i = 1; i < datal.length+1; i++){
        // if(i === 1){
        //   numSection++;
        //   console.log(datal[i-1])
        //   positionSection = {...positionSection, [numSection]: [datal[i-1]]}
        //   positionSection2 = {...positionSection2, [numSection]: {start:i-1,end:i-1}}
        //   positionSlides = {
        //     ...positionSlides,
        //     [i-1]: {...datal[i-1], type: datal[i-1].typeshow === "assessment" ? "test" 
        //       : datal[i-1].typeshow === "slide" ? "info" : "section"}
        //   }  
        // }

        if(datal[i-1].typeshow === "section"){
          numSection++;
          positionSection = {...positionSection, [numSection]: [datal[i-1]]}
          positionSection2 = {...positionSection2, [numSection]: {start:i,end:i}}
        }else if(numSection !== 0){
          positionSection[numSection] = [...positionSection[numSection], datal[i-1]];
          (positionSection2[numSection] || {}).end = i;
        }

        positionSlides = {
          ...positionSlides,
          [i]: {...datal[i-1], type: datal[i-1].typeshow === "assessment" ? "test" 
            : datal[i-1].typeshow === "slide" ? "info" : "section"}
        }
        if(datal.length === i){
          positionSlides[i+1] = {...datal[i-1],assessmentActivities: assessmentReviuw,id:"reviuw",type: "reviuw"};
          positionSlides[i+2] = {...datal[i-1],id:"completed",type: "completed"};
          numSection++;
          positionSection = {...positionSection, [numSection]: [{...datal[i-1],assessmentActivities: assessmentReviuw, id:"reviuw",type:"reviuw"}]};
          positionSection2 = {...positionSection2, [numSection]: {start:i+1,end:i+1}};
          numSection++;
          positionSection = {...positionSection, [numSection]: [{...datal[i-1],id:"completed",type:"completed"}]};
          positionSection2 = {...positionSection2, [numSection]: {start:i+2,end:i+2}};
        }
        if((datal[i-1] || {}).id && datal[i-1].typeshow === "assessment"){
          let assesments
          for(let y = 0; y < (datal[i-1]?.assessmentActivities || []).length; y++){
            assesments = {...assesments,[(datal[i-1]?.assessmentActivities || [])[y].uuid]: (datal[i-1]?.assessmentActivities || [])[y]?.['correct-option']}
          }

          responseD = {
            ...responseD,
            [(datal[i-1] || {}).id]: assesments
          }
        }
      }

      setRelationSideIndex(positionSection)
      setRelationSideIndex2(positionSection2)
      setRelationCorrectResponses(responseD)
      setRelationSlides(positionSlides)
    }
  },[crashCourse])

  useEffect(() => {
    setBulWaitDuplicate(true)
    setTimeout(() => {
      setBulWaitDuplicate(false)
    }, 6000);
  },[])

  useEffect(() => {
    if((crashCourseProgress || {}).id && JSON.stringify(responseTests) !== '{}' && JSON.stringify(crashCourseProgress.testsAnswers || '{}') !== JSON.stringify(responseTests || '{}') && 
    !isEqual(crashCourseProgress.testsAnswers, responseTests)){
      setUploading(true)
      let idMoment = crashCourseProgress.id;

      localStorage.setItem(`testsAnswers${crashCourse.id}`, JSON.stringify(responseTests));
      if(clockNextSaveState.current){clearTimeout(clockNextSaveState.current)};
      clockNextSaveState.current = setTimeout(() => {
        setUploading(false)
        if(memorySlideChange === match.params.id && !bulWaitDuplicate){
          updateCrashCourseUserProgress({
            testsAnswers: responseTests,
            id: idMoment
          }); 
        }
        
      }, timeToLoad);
    }    
  },[responseTests])

  const objetosIguales = (obj1, obj2) => {
    const keys1 = Object.keys(obj1 || {});
    const keys2 = Object.keys(obj2 || {});
    const totalKeys = Math.max(keys1.length, keys2.length);

    if (totalKeys === 0) return true;

    const matchingKeys = keys1.filter(key => obj2[key] === obj1[key]).length;
    return (matchingKeys / totalKeys) >= 1;
  }

  const descriptionSlide = (data) => (
    <CollapseDescription
      title={data?.title}
      content={
        <ScaleText
          content={
            <div
              className="container-will-learn-collapsee"
              style={{ height: "450px", maxHeight: "450px", overflow:'scroll', width:'100%' }}
              dangerouslySetInnerHTML={{__html: data?.description?.replaceAll('<a hr', '<a target="_blank" hr') }}
            />
          }
        />
        
      }
    />
  )

  let optionsTest = (item,data,type='normal') => {

    const optionsTemplate = (item) => {
      return item.options.map((option,index2) => {
        let bulText = (((relationCorrectResponses || [])[(data || {}).id] || {})[(item || {}).uuid] || '') === option;
        let bulSelected = ((((responseTests || [])[(data || {}).id] || {}).memory || [])[(item || {}).uuid] || []).includes(option);
        return (
          <div key={option} style={{ margin: "8px 0", position:'relative', display:'flex',alignItems:'center' }} className="container-checkbox-case">
            {(item.uuid !== 'reviuw' && type === 'normal') && (<><label for={`radio-${(item || {}).uuid}-${index2}`} style={{position:'absolute',top:'3px', width:'17px',height:'17px',display:'flex',left:'-20px',justifyContent:'center',alignItems:'center', background:'green',borderRadius:'50% 50%',zIndex:'10',opacity:`${(bulSelected && bulText) ? 1 : 0}`,transition:'all 0.4s ease-in-out'}}>
              <CheckOutlined style={{color:"white",fontSize:'12px'}}/>
            </label>
            <label for={`radio-${(item || {}).uuid}-${index2}`} style={{position:'absolute',top:'3px', width:'17px',height:'17px',display:'flex',left:'-20px',justifyContent:'center',alignItems:'center', background:'#fe5621',borderRadius:'50% 50%',zIndex:'10',opacity:`${(bulSelected && !bulText) ? 1 : 0}`,transition:'all 0.4s ease-in-out'}}>
              <CloseOutlined style={{color:"white",fontSize:'12px'}}/>
            </label></>)}
            <Radio id={`radio-${(item || {}).uuid}-${index2}`} value={option}>{option}</Radio>
          </div>
        )
      })
    }

    return (item.type === 'radio' || !item.type)  ? (<Radio.Group 
      disabled={bulWaitDuplicate}
      size="large" 
      style={(item.uuid === 'reviuw' || type === 'reviuw') ? {width:'100%',display:'flex',justifyContent:'center',alignItems:'center',marginBottom:'20px',marginTop:'20px'} : {}}
      value={((responseTests || [])[(data || {}).id] || {})[(item || {}).uuid]} 
      onChange={(e) => {
        setResponsesTests({
          ...responseTests,
          [(data || {}).id]:{
            ...((responseTests || [])[(data || {}).id] || {}),
            [(item || {}).uuid]: e.target.value,
            memory: {
              ...(((responseTests || [])[(data || {}).id] || {}).memory || {}),
              [(item || {}).uuid]: [...new Set([
                // ...(((((responseTests || [])[(data || {}).id] || {}).memory || []) || {})[(item || {}).uuid] || []),
                e.target.value
              ])]
            }
          }
        })
    }}>
      {(item.uuid === 'reviuw' || type === 'reviuw') 
        ? <Space direction="horizontal" >{optionsTemplate(item)}</Space> 
        : optionsTemplate(item)
      }
    </Radio.Group>) : (item.type === 'text') ? (<CustomInput
      disabled={bulWaitDuplicate}
      multiple={true}
      size="large"
      style={{marginBottom:'20px',marginTop:'20px'}}
      value={((responseTests || [])[(data || {}).id] || {})[(item || {}).uuid]} 
      onChange={(e) => {
        setResponsesTests({
          ...responseTests,
          [(data || {}).id]:{
            ...((responseTests || [])[(data || {}).id] || {}),
            [(item || {}).uuid]: e,
            memory: {
              ...(((responseTests || [])[(data || {}).id] || {}).memory || {}),
              [(item || {}).uuid]: [...new Set([
                // ...(((((responseTests || [])[(data || {}).id] || {}).memory || []) || {})[(item || {}).uuid] || []),
                e
              ])]
            }
          }
        })
      }}
    ></CustomInput>) : (<></>)
  }

  const testSlide = (data) => (
    <CollapseDescription
      title={data?.title}
      content={
        <div className="container-will-learn-collapsee" style={{ height: "450px", maxHeight: "450px", overflow:'scroll', width: "100%", padding: "20px"}} >
          <ScaleText
            content={data?.assessmentActivities?.map((item,index) => {
              return (
                <div key={index}>
                  <h3>{item.question}</h3>
                  {optionsTest(item,data)}
                </div>
              );
            })}
          />
        </div>
      }
    />
  )

  const textCustom = () => {
    if(slideSelect[pageNumber2]){
      return (slideSelect[pageNumber2 + 1]?.type === 'info' || slideSelect[pageNumber2 + 1]?.type === 'section')
        ? 'NEXT' 
        : slideSelect[pageNumber2 + 1]?.type === 'test'
          ? 'TAKE TEST'
          : (slideSelect[pageNumber2 + 1] || {}).type === 'reviuw' ? 'REVIEW' : 'COMPLETE'
    }else{
      return (relationSlides[pageNumber + 1]?.type === 'info' || relationSlides[pageNumber + 1]?.type === 'section')
        ? 'NEXT' 
        : relationSlides[pageNumber + 1]?.type === 'test'
          ? `TAKE TEST`
          : (relationSlides[pageNumber + 1] || {}).type === 'reviuw' ? 'REVIEW' : 'COMPLETE'
    }
  }

  useEffect(() => {
    let keys = Object.keys(relationSideIndex);
    (keys || []).map((e) => {
      if(Number(pageNumber) >= Number(relationSideIndex2?.[e]?.start) && Number(pageNumber) <= Number(((relationSideIndex2 || {})[e] || {}).end)){
        if(conjuntSelected !== relationSideIndex?.[e]?.[0]?.id){
          let newData = [...new Set([...sectionActive, relationSideIndex?.[e]?.[0]?.id])]
          seSectionActive(newData.filter(ar => ar !== conjuntSelected))
          setConjuntSelected(relationSideIndex?.[e]?.[0]?.id)
        }
      }
    });
  },[pageNumber,relationSideIndex])

  const lastTestReviuw = (data) => {
    return (
      <CollapseDescription
        title="Final Review"
        content={
          <div className="container-will-learn-collapsee" style={{ height: "450px", maxHeight: "450px", overflowX: "auto", width: "100%", padding: "20px",display:'flex',flexDirection:'column',gap:'50px'}} >
            {(assessmentReviuw || []).map((item,index) => {
              return (
                <div key={index}>
                  <h3><span style={{
                    display: 'inline-block',
                    marginRight: '4px',
                    color: '#ff4d4f',
                    fontSize: '18px',
                    fontFamily: 'SimSun, sans-serif',
                    lineHeight: '2',
                  }}>*</span>{item.question}</h3>
                  {optionsTest(item,data,'reviuw')}
                </div>
              );
            })}
          </div>
        }
      />  
    )
  }

  const saveProgress = () => {
    pagesSavedControl.current = [...pagesSavedControl.current, String(pageNumber)]
    setUploading3(true)
    let idMoment = crashCourseProgress.id;
    localStorage.setItem(`pagesVisited${crashCourse.id}`, JSON.stringify(
      [...new Set(pagesSavedControl.current.map(e => String(e)))]
    ));
    if(clockNextSaveState2.current){clearTimeout(clockNextSaveState2.current)}
    clockNextSaveState2.current = setTimeout(() => {
      setUploading3(false)
      if(((relationSlides || [])[Number(pageNumber)+1] || {}).type === 'completed' && !pagesMantain.current.includes(String(Number(pageNumber)+1))){
        if(memorySlideChange === match.params.id && !bulWaitDuplicate){
          let newArrayS = [...pagesSavedControl.current, Number(pageNumber)+1];
          updateCrashCourseUserProgress({
            pagesVisited: [...new Set(newArrayS.map(e => String(e)))],
            id: idMoment
          }) 
          pagesSavedControl.current = [...new Set(newArrayS.map(e => String(e)))]
        }
      }else if(!pagesMantain.current.includes(String(pageNumber))){
        if(memorySlideChange === match.params.id && !bulWaitDuplicate){
          updateCrashCourseUserProgress({
            pagesVisited: [...new Set(pagesSavedControl.current.map(e => String(e)))],
            id: idMoment
          }) 
        }
      }
    }, timeToLoad);
  }

  return (
    <div className="container-certificates" translate="no" style={{paddingLeft:'20px',paddingRight:'20px'}}>
      <div className="container-buttons-certificate">
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "20px" }}>
          <div className="title-list-certificates" style={{ minWidth: "300px" }}>
            {crashCourse.title}
          </div>
          <div className="title-list-certificates" style={{ minWidth: "100px", minHeight: "38px", maxHeight: "38px", background:'#fe5621', borderColor:'#fe5621' }}>
            {(uploading || uploading2 || uploading3) ? (<>
              <LoadingOutlined style={{marginRight:'10px'}} /> Saving...
            </>) : (<>
              <CloudUploadOutlined style={{marginRight:'10px'}} /> Saved
            </>)}
          </div>
        </div>
      </div>
      <div className="container-firstsegment-certificate2" style={{gap:'10px'}}>
        <div className="container-side-index">
          <Collapse 
            bordered={false}
            expandIcon={() => (<></>)}
            activeKey={[]}
            className="site-collapse-custom-collapse"
          >
            <Panel
              header={<HeaderCollapseMap 
                pagesVisitedMap={Object.keys(crashCourseProgress)?.length > 0} 
                inPage={pageNumber === null}
                data={{type: 'start',title: 'Crash Course Description'}} 
                onClick={() => {setPageNumber(null)}
              } />}
              key={1}
              className="site-collapse-custom-panel"
              style={pageNumber === null
                ? {borderRight: '#fe5621 2px solid', background: "white", transition: 'all 1s ease-in-out '} : { background: "white", transition: 'all 1s ease-in-out ', borderRight: 'transparent 2px solid' }
              }
            ></Panel>
          </Collapse>  
          { Object.keys(relationSideIndex)?.map((e,index) => {
            let startF = ((relationSideIndex2 || [])[e] || {}).start;
            let endF = ((relationSideIndex2 || [])[e] || {}).end
            return  (<div style={{width:'100%',height:'auto'}} key={index}>
              <Collapse
                bordered={false}
                expandIcon={() => (<></>)}
                activeKey={sectionActive.includes(relationSideIndex?.[e]?.[0]?.id) ? [1] : []}
                className="site-collapse-custom-collapse"
              >
                <Panel
                  header={<HeaderCollapseMap 
                    pagesVisitedMap={(pagesSavedControl.current || []).map(e => String(e) || {includes: () => {}}).includes(String(startF))} 
                    inPage={(relationSlides[pageNumber]?.id === relationSideIndex?.[e]?.[0]?.id)}
                    data={relationSideIndex?.[e]?.[0]} 
                    onClick={() => {
                      let pagesNumber = Number(startF)
                      if(relationSideIndex?.[e]?.[0]?.type !== 'completed'){
                        let dataF = {...relationSideIndex}
                        let data = sectionActive.includes(dataF?.[e]?.[0]?.id) 
                        ? sectionActive.filter(as => {
                          return Number(as) !== Number(dataF?.[e]?.[0]?.id);
                        }) : [...sectionActive, dataF?.[e]?.[0]?.id];
                        seSectionActive([...new Set(data)])
                      }
                      if((pagesSavedControl.current || []).map(e => String(e) || {includes: () => {}}).includes(String(pagesNumber))){
                        setPageNumber(pagesNumber)
                      }
                    }
                  } />}
                  key={1}
                  className="site-collapse-custom-panel"
                  style={Number(pageNumber) >= Number(startF) && Number(pageNumber) <= Number(endF)
                    ? {borderRight: '#fe5621 2px solid', background: "white", transition: 'all 1s ease-in-out '} : { background: "white", transition: 'all 1s ease-in-out ', borderRight: 'transparent 2px solid' }
                  }
                >
                  {relationSideIndex?.[e]?.map((a,index) => {
                    let pagesNumber = Number(startF) + Number(index);
                    let pagesVisitedMap = (pagesSavedControl.current || []).map(e => String(e) || {includes: () => {}}).includes(String(pagesNumber))
                    return (<p
                      className={"parraf-collapse-sitemap"} 
                      style={index === 0 ? {opacity:'0',height:'0px',padding:'0px',margin:'0px',direction: "ltr",textAlign:'start',justifyContent:'flex-start'} : {opacity:'1',direction: "ltr",textAlign:'start',justifyContent:'flex-start'}} 
                      key={index}
                      onClick={() => {
                        if(pagesVisitedMap){
                          setPageNumber(pagesNumber)
                        }else{
                          notification.error({
                            message: "You can't jump to this section yet. Please complete the previous sections before. Thank you",
                          });
                        }
                      }}
                    >
                      {<div className="check-map" style={pagesVisitedMap 
                        ? {opacity:'1'} : {opacity:'0'}
                      }><CheckOutlined style={{color:"white",fontSize:'8px'}}/></div>}
                      {index === 0 ? 'Index' : a?.title}
                      <div style={(relationSlides[pageNumber]?.id === a?.id && !pagesVisitedMap) 
                        ? {opacity:'1'} : {opacity:'0'}
                      } className="circul-map"></div>
                    </p>
                  )})}
                </Panel>
              </Collapse>
            </div>)
          })}
          
        </div>
        <div className="container-left-certificate">
          {pageNumber === null && (
            <>
              <CollapseDescription
                title="Description"
                widthTitle="360px"
                content={
                  <ScaleText
                    content={<div
                      style={{width:'100%'}}
                      className="container-will-learn-collapsee"
                      dangerouslySetInnerHTML={{
                        __html: crashCourse?.description?.replaceAll('<a hr', '<a target="_blank" hr'),
                      }}
                    />}
                  />
                }
              />
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <CustomButton
                  className="button-start-now"
                  style={{ background: "#1A2842", width: "max-content", color: "white", minWidth: "180px", textAlign: "center", marginRight: '20px' }}
                  text={(crashCourseProgress || {}).id ? "NEXT" : "START NOW"}
                  onClick={() => {
                    startCrashCourse()
                  }}
                />
              </div>
              <CollapseDescription
                title="What You Will Learn"
                widthTitle="360px"
                content={
                  <div className="container-will-learn-collapse">
                    {(crashCourse?.youWillLearn?.length > 0
                      ? crashCourse?.youWillLearn
                      : []
                    )?.map((e, index) => {
                      return (
                        <div
                          key={index}
                          className="container-will-learn-collapse"
                        >
                          <p>{e}</p>
                        </div>
                      );
                    })}
                  </div>
                }
              />
            </>
          )}
          {(relationSlides && pageNumber !== null) && <>
            {(relationSlides[pageNumber]?.type === 'info' || relationSlides[pageNumber]?.type === 'section') && descriptionSlide(relationSlides[pageNumber])}
            {(relationSlides[pageNumber]?.type === 'test') && testSlide(relationSlides[pageNumber])}
            {((relationSlides[pageNumber] || {}).type === 'reviuw') && lastTestReviuw(relationSlides[pageNumber])}
            {(relationSlides[pageNumber]?.type === 'completed') && (<>
              <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column', width:'100%',height:'auto'}}>
                {!bulWaitDuplicate && <CertificateCrashCourse
                  idCrash={crashCourse?.id}
                  onlyCertificate={true}
                  slug={crashCourse?.slug}
                />}
              </div>
            </>)}
          <React.Fragment>
            <div style={{ display: "flex", justifyContent: "center", marginTop:'20px' }}>
              <div style={{ display: "flex", gap: "15px" }}>
                <CustomButton
                  className="button-start-now"
                  style={{ background: "#F05C27", width: "max-content", color: "white", minWidth: "200px", textAlign: "center", display: "flex", alignItems: "center", gap: "5px" }}
                  icon={<StepBackwardOutlined />}
                  text="PREVIOUS"
                  disabled={bulWaitDuplicate}
                  loading={bulWaitDuplicate}
                  onClick={() => {
                    if(slideSelect[pageNumber2]){
                      if(pageNumber2 === 0){
                        setPageNumber2(null)
                        setSlideSelect({})
                      }else{
                        setPageNumber2((prev) => --prev)
                      }
                    }else{
                      setPageNumber((prev) => {
                        if (prev === 1) {
                          return null;
                        } else {
                          return --prev;
                        }
                      });
                    }
                    
                  }}
                />
                {(relationSlides[pageNumber]?.type !== 'completed') && <CustomButton
                  className="button-start-now"
                  style={{ background: "#F05C27", width: "max-content", color: "white", minWidth: "180px", textAlign: "center", display: "flex", alignItems: "center", gap: "5px", flexDirection: "row-reverse", justifyContent: "space-around" }}
                  icon={<StepForwardOutlined />}
                  disabled={bulWaitDuplicate}
                  loading={bulWaitDuplicate}
                  text={textCustom()}
                  onClick={() => {
                    let relationSP = relationSlides?.[pageNumber];
                    let rtWithoutFilter = {...(responseTests || [])[relationSP?.id]};
                    delete rtWithoutFilter.memory;
                    delete rtWithoutFilter.reviuw;
                    const uuidsRelationSP = ((relationSP || {}).assessmentActivities || []).map(item => item.uuid);
                    const rt = (Object.keys(rtWithoutFilter || {}) || [])
                      .filter(key => (uuidsRelationSP || []).includes(key))
                      .reduce((acc, key) => {
                          acc[key] = rtWithoutFilter[key];
                          return acc;
                      }, {});
                    if(slideSelect[pageNumber2]){
                      if(pageNumber2 === 1){
                        setPageNumber2(null)
                        setSlideSelect({})
                      }else{
                        setPageNumber2((prev) => ++prev)
                      }
                    }else{
                      if(((relationSP || {}).type === 'test' || (relationSP || {}).type === 'reviuw')
                      && relationSP?.assessmentActivities?.length !== Object.keys(rt || {})?.length){
                        notification.error({
                          message: "Please select an option before proceeding.",
                        });
                        return
                      }
                      if(relationSP?.type === 'test'){
                        if(!objetosIguales(rt,relationCorrectResponses[relationSP?.id])){
                          setModal(true)
                          return
                        }
                      }
                      if((relationSP || {}).type === 'test'){
                        if(((relationSP || {}).assessmentActivities || []).length !== (Object.keys(rt || {}) || []).length){
                          notification.error({
                            message: "Please select an option before proceeding.",
                          });
                          return
                        }
                        setPageNumber((prev) => ++prev);
                        saveProgress()
                        // setModal2(true);
                      }else{
                        setPageNumber((prev) => ++prev); 
                        saveProgress();
                      }
                    }
                  }}
                />}
                {relationSlides[pageNumber]?.type !== 'completed' && <CustomButton
                  className="button-start-now"
                  style={{ background: "transparent", border:'#F05C27 solid 2px', width: "max-content", color: "#F05C27", minWidth: "180px", textAlign: "center", display: "flex", alignItems: "center", gap: "5px", flexDirection: "row-reverse", justifyContent: "space-around" }}
                  text={`Page ${pageNumber} of ${countSlides + 1}`}
                  onClick={() => {
                  }}
                />}
              </div>
            </div>
          </React.Fragment>
          </>}
        </div>
        <Modal
          className="modal-login"
          width={"480px"}
          style={{ height: "auto", top: "50px" }}
          visible={modal}
          onCancel={() => setModal(false)}
          onOk={() => setModal(false)}
        >
          <div className="login-page-2" style={{paddingTop:'100px'}}>
            <div
              className="login-dialog"
              style={{ paddingTop: "40px", paddingBottom: "40px" }}
            >
              <div className="login-dialog-header" style={{ padding: "10px" }}>
                <h3 style={{ textAlign: "center" }}>
                  All your responses must be correct to advance to the next section. Please go back to the assessment and try again.
                </h3>
                <div
                  className="login-dialog-logo"
                  style={{ borderRadius: "50%", background: "white" }}
                >
                  <img src={IconLogo} alt="login-logo" />
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {bulCompleteProfile && (
          <div className="complete-profile">
            <ModalCompleteYourProfile
              userProfile={userProfile}
              get={getUser}
              setBulKnowRegister={() => {}}
              setBulCompleteProfile={setBulCompleteProfile}
              onClose={() => setBulCompleteProfile(false)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allNewCources: courseSelector(state).allNewCources,
  courseSelected: courseSelector(state).courseSelected,
  userProfile: homeSelector(state).userProfile,
  certificateUsersInfo: courseSelector(state).certificateUsersInfo,

  crashCourseD: crashCourseSelector(state).crashCourse,
  crashCourseProgressD: crashCourseSelector(state).crashCourseProgress
});

const mapDispatchToProps = {
  ...courseActions,
  ...crashCourseActions,
  ...crashCourseProgressActions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadershipProgramPage);